import { render, staticRenderFns } from "./OriginalText.vue?vue&type=template&id=4d3f4198&scoped=true&"
import script from "./OriginalText.vue?vue&type=script&lang=ts&"
export * from "./OriginalText.vue?vue&type=script&lang=ts&"
import style0 from "./OriginalText.vue?vue&type=style&index=0&id=4d3f4198&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3f4198",
  null
  
)

export default component.exports